import * as React from 'react';
import { DefaultLayout } from '../../../components/DefaultLayout';
import { Seo } from "../../../components/Seo";

import { YandexMetrika } from '../../../components/YandexMetrika';
import { MailRu } from '../../../components/MailRu';
import { TikTok } from '../../../components/TikTok';
import { VKPixel } from '../../../components/VKPixel';
import { AdvCake } from '../../../components/AdvCake';

import {
  Screen1, Tasks, Approach, Principles, Process, Program, Levels, Cost, Reviews, Faq, Experts, EduLicenses,
  main
} from "../../../components/LandingTemplates/angliyskiy_dlya_vashih_celey";

import { GetCourseWidget } from '../../../components/GetCourseWidget';
import { AdvanceRocket } from '../../../components/AdvanceRocket';
import { TextReviews } from '../../../components/TextReviews';
import { FooterFull } from '../../../components/FooterFull';

import textReviews from '../../../components/LandingTemplates/angliyskiy_dlya_vashih_celey/data/textReviews';

const TITLE = 'Английский для ваших целей - Интерактивный онлайн-курс английского языка';
const DESCRIPTION = 'Онлайн-курс изучения английского языка: теория, практика, интерактивные уроки английского на платформе Advance. Авторские методики обучения!';
export const Head = () => (
  <Seo title={TITLE} description={DESCRIPTION}>
    <title>{TITLE}</title>
  </Seo>
);
const Page = (
  {
    widgetConsult = <GetCourseWidget hash={'1e54e6070c9263f8619d789abe86a9d4e7c0d540'} id={'703599'}/>,
    widgetStandart = <GetCourseWidget hash={'1e44f4e876bbd97a4f5a91ac8ad215701620f7f2'} id={'699343'} />,
    widgetPremium = <GetCourseWidget hash={'f7e0730d66c2667793bd01f554ba89da7816acb3'} id={'699361'} />
  }
) => (
  <DefaultLayout>
    <YandexMetrika />
    <MailRu />
    <TikTok />
    <VKPixel />
    <AdvCake />

    <Screen1 />

    <main>
      <Tasks />
      <Approach widget={widgetConsult} />
      <Principles />
      <Process />
      <Program />
      <Levels />
      <AdvanceRocket className={main.rocket} />
      <Cost widgetStandart={widgetStandart} widgetPremium={widgetPremium} />
      <Reviews />
      <TextReviews data={textReviews} />
      <Faq />
      <Experts background={'#FAF6FF'} />
      <EduLicenses background={'#FFF'} />
    </main>

    <FooterFull />

  </DefaultLayout>
);

export default Page;
